import { myListsEditListFormStyles } from "@insite/content-library/Widgets/MyLists/MyListsEditListForm";
import { filterStyles } from "@insite/content-library/Widgets/MyLists/MyListsFilter";
import { listStyles } from "@insite/content-library/Widgets/MyLists/MyListsList";
import { searchFieldProductNumberStyles } from "@insite/content-library/Widgets/MyLists/MyListsSearchFieldProductNumber";
import { sortControlStyles } from "@insite/content-library/Widgets/MyLists/MyListsSortControl";
import ChevronsUpDown from "@insite/mobius/Icons/ChevronsUpDown";
import { css } from "styled-components";

listStyles.cardContainer = {
    cardDivider: {
        css: css`
            width: 100%;
            border: none;
        `,
    },
};

myListsEditListFormStyles.cancelButton = {
    mergeCss: true,
    color: "secondary",
    css: css`
        margin-right: 10px;
    `,
};

sortControlStyles.sortByOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            span {
                color: #ffffff !important;
            }
            ul {
                background: #ffffff !important;
            }
        `,
    },
    iconProps: { src: ChevronsUpDown },
};

filterStyles.clearFiltersButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        float: right;
        margin-bottom: 25px;
        border: 1px solid rgb(1, 11, 19) !important;
    `,
};

searchFieldProductNumberStyles.searchDynamicDropdown = {
    cssOverrides: {
        list: css`
            background: #ffffff !important;
        `,
    },
};
